<!-- eslint-disable -->
<template>
  <b-card class="in-cell-call-overview-requested">
    <b-card-title>
      <section class="d-flex justify-content-between align-items-center">
        Call Overview
        <b-badge v-if="visit.booked_by"
                 variant="primary">
          {{ visit.booked_by === 'Visitor' ? 'Visitor' : $options.filters.term(visit.booked_by.toLowerCase(), true) }}
          requested
        </b-badge>
      </section>
    </b-card-title>
    <slot></slot>

    <b-alert v-if="visitorsFirstCall" class="p-1" show variant="danger">
      This is the visitor's first video call
    </b-alert>

    <p class="detail-item mb-1">
      <b cy="o-name">{{ visit.visitor.firstname }} {{ visit.visitor.lastname }}</b> has requested a video call with
      resident
      <b cy="o-prisoner">{{ visit.prisoner.firstname }} {{ visit.prisoner.lastname }}</b>, {{ 'prison' | term(true) }}
      number: <b>{{ visit.prisoner.prisoner_number }}</b>,
      on the <b cy="o-date">{{ getRequestedOrBookedDate() }}</b>
    </p>

    <p class="detail-item" v-if="!loadingVisitsHadOnMonth">
      <b>{{ visit.prisoner.firstname }}</b> has had <b>{{ visitsHadThisMonth }}</b> video calls in the selected month so far.
      <span
        v-if="prison.check_for_allowed_visits_per_month">Residents are usually allowed a limit of <b>{{
          prison.allowed_visits_per_month || 2
        }}</b> video calls a month.</span>
    </p>

    <p class="text-danger" v-if="dateRestricted">This booking date overlaps with a restricted date period.</p>

    <section>
      <h4 class="mt-2">Book Video Call For</h4>

      <section v-if="!loadingVisitStock" class="my-2">
        <b-btn variant="primary" class="full-width"
               @click="selectSlot1()"
               :disabled="!requestedSlot1HasStock()"
        >
          {{ getRequestedFor1() }}
        </b-btn>
      </section>
      <section>
        <p class="mb-0">Available Fund Tokens: <b>{{ fundTokens }}</b></p>

        <!-- form -->
        <validation-observer ref="bookValidation">
          <b-form class="auth-login-form mt-2" @submit.prevent>

            <!-- Record Call -->
            <validation-provider
              #default="{ errors }"
              name="Record Visit"
              :rules="{ required: true }">
              <b-form-checkbox v-model="form.recordVisit" name="check-button" switch class="mb-1">
                Record Video Call
              </b-form-checkbox>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>

            <!-- Transcribe call -->
            <validation-provider
              v-if="prison && prison.purple_scribe_default_option && form.recordVisit"
              #default="{ errors }"
              name="Transcribe Visit"
              :rules="{ required: true }">
              <b-form-checkbox v-model="form.purpleScribeEnabled" name="check-button" switch class="mb-1">
                Transcribe with <span class="text-primary text-bold">Purple Scribe</span>
              </b-form-checkbox>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>

            <validation-provider
              #default="{ errors }" name="Security Band" :rules="{ required: true }">
              <label>Security Band</label>
              <b-form-select v-model="form.securityBand" class="">
                <option value="Off">Off</option>
                <option value="Low">Low</option>
                <option value="Medium">Medium</option>
                <option value="High">High</option>
                <option value="Max">Max</option>
              </b-form-select>
              <small class="text-danger">{{ errors[0] }}</small>
              <small v-if="form.securityBand==='Off'">In call security will be turned off. Ideal of special
                scenarios.</small>
              <small v-if="form.securityBand==='Low'">In call security will still run but at a relaxed pace. Ideal for
                trusted residents with children on the video call.</small>
              <small v-if="form.securityBand==='Medium'">Balance of in-call experience for the visitor and in call
                security.</small>
              <small v-if="form.securityBand==='High'">A high level of security. May reduce the in call experience for
                the visitor/resident.</small>
              <small v-if="form.securityBand==='Max'">The highest level of security. Please note in call experience may
                suffer for the visitor/resident.</small>
            </validation-provider>

            <validation-provider
              #default="{ errors }" class="mt-1"
              name="Adult Content Settings"
              :rules="{ required: true }"
            >
              <label class="d-block mt-1">Adult Content Setting</label>
              <select v-model="form.adultContentSettings" class="form-control">
                <option value="Off">Off</option>
                <option value="Alert">Alert</option>
                <option value="Pause">Pause</option>
              </select>
              <small class="text-danger">{{ errors[0] }}</small>
              <small v-if="form.adultContentSettings === 'Off'">Adult content detection will be turned off and no action
                taken by the system.</small>
              <small v-if="form.adultContentSettings === 'Alert'">The master terminal will be informed of any adult
                content that is detected. It will be up to the staff member to take action.</small>
              <small v-if="form.adultContentSettings === 'Pause'">The system will automatically pause the call and warn
                the visitor. The visitor will then have to pass through reverification.</small>
            </validation-provider>

            <validation-provider
              #default="{ errors }" class="mt-1"
              name="Invalid Face Action"
              :rules="{ required: true }"
            >
              <label class="d-block mt-1">Invalid Face Action</label>
              <select v-model="form.invalidFaceEventAction" class="form-control">
                <option value="Pause">Pause</option>
                <option value="Alert">Alert</option>
              </select>
              <small class="text-danger">{{ errors[0] }}</small>
              <small v-if="form.invalidFaceEventAction === 'Pause'">Invalid face detection will cause the call to be
                paused. The primary visitor will then have to re-verify themselves.</small>
              <small v-if="form.invalidFaceEventAction === 'Alert'">The master terminal will receive a notification when
                an invalid face is detected. Leaving it up to the staff member to pause and resume the call.</small>
            </validation-provider>

            <section class="my-1" v-if="isUserBannedOnBookingSlot()">
              <p class="text-danger font-weight-bold">
                Unable to book for that slot as the visitor is banned on that date.
              </p>
            </section>

            <section class="my-1" v-if="prison && prison.allow_book_button">
              <b-btn
                class="full-width" variant="primary"
                @click="approveVisitWarning(false)">
                <span class="fas fa-check"></span> Approve and request payment
              </b-btn>
            </section>
            <section class="mt-1" v-if="prison && prison.allow_funding_in_cell_calls">
              <b-btn
                class="full-width" variant="success"
                @click="approveVisitWarning(true)"
                :disabled="(!validFundTokens() || !validApprove() && !loadingVisitorBans) || isUserBannedOnBookingSlot()">
                <span class="fas fa-check"></span> Approve and fund
              </b-btn>
            </section>
          </b-form>
        </validation-observer>
      </section>

      <section class="d-flex justify-content-end mt-2">
        <b-btn @click="showModal('modal-reject')" variant="danger">Reject request</b-btn>
      </section>
    </section>

    <b-modal id="modal-reject" hide-footer>
      <reject-call @close="closeAndRefresh()" :call="visit"></reject-call>
    </b-modal>
  </b-card>
</template>
<!-- eslint-enable -->

<script>
import { mapState } from 'vuex';
import RejectCall from '@/components/calls/RejectCall.vue';
import { getVisitBookedForDate, getVisitRequestedDates, convertYearDayToDate } from '@/util/helpers';
import VisitService from '@/services/VisitService';
import PrisonService from '@/services/PrisonService';
import moment from 'moment';
import { ERROR_CODES } from '@/util/errorCodes';
import InCellBookingSlotsService from '@/services/InCellBookingSlotsService';

export default {
  components: {
    RejectCall,
  },
  props: {},
  data() {
    return {
      loadingVisitsHadOnMonth: true,
      loadingVisitorBans: true,
      visitsHadThisMonth: 0,
      loadingVisitStock: true,
      bookingSlotStock: null,
      slotSelected: '',
      fundTokens: '-',
      visitorBans: [],
      form: {
        recordVisit: this.$store.state.prison.prison.default_call_recording,
        purpleScribeEnabled: this.$store.state.prison.prison.purple_scribe_default_option || false,
        securityBand: 'High',
        adultContentSettings: 'Pause',
        invalidFaceEventAction: 'Pause',
      },
    };
  },
  computed: {
    ...mapState({
      prison: state => state.prison.prison,
      visit: state => state.inCellVisits.visit,
      dateRestricted: state => state.booking.dateRestricted,
      visitorsFirstCall: state => state.inCellVisits.visitorsFirstCall,
    }),
  },
  mounted() {
    this.closeAndRefresh();
    this.checkRestrictedDates();
  },
  methods: {
    showModal(name) {
      this.$bvModal.show(name);
    },
    async closeAndRefresh() {
      this.$bvModal.hide('modal-reject');
      this.getVisitsHadThisMonth();
      this.getBookingSlotStock();
      this.getFundTokens();
      this.getVisitorsBan();
      this.$emit('refresh');
    },
    getRequestedOrBookedDate() {
      if (this.visit) {
        if (this.visit.booked_slot) {
          const bookedFor = getVisitBookedForDate(this.visit);
          return bookedFor.bookedFor;
        }
        const requestedFor = getVisitRequestedDates(this.visit);
        if (this.visit.requested_booking_slot_2) {
          return `${requestedFor.requestedFor1} or ${requestedFor.requestedFor2}`;
        }
        return requestedFor.requestedFor1;
      }
      return '-';
    },
    getVisitsHadThisMonth() {
      VisitService.getNumberOfVisitsThisMonth(this.visit.prisoner.prisoner_number, this.visit.requested_booking_slot_1.start_date_time).then(res => {
        this.visitsHadThisMonth = res.data.num_of_visits;
        this.loadingVisitsHadOnMonth = false;
      }).catch(() => {
        this.$toast.error('Something went wrong, please refresh the page', {
          toastClassName: ['toast-std', 'warning-toast'],
        });
      });
    },
    getBookingSlotStock() {
      InCellBookingSlotsService.getBookingSlotsAvailabilityForVisit(this.visit._id).then(res => {
        this.bookingSlotStock = res.data;
        // Auto select booking slot 1 if it has stock
        if (this.requestedSlot1HasStock()) {
          this.selectSlot1();
        }
      }).catch(() => {
        this.$toast.error('Something went wrong, please refresh the page', {
          toastClassName: ['toast-std', 'warning-toast'],
        });
      }).finally(() => {
        this.loadingVisitStock = false;
      });
    },
    getFundTokens() {
      PrisonService.getFundTokens().then(({ data }) => {
        this.fundTokens = data.tokens;
      }).catch(() => {
        this.$toast.error('Something went wrong getting your fund tokens', {
          toastClassName: ['toast-std', 'warning-toast'],
        });
      });
    },
    requestedSlot1HasStock() {
      return this.bookingSlotStock.requested_booking_slot_1_stock > 0;
    },
    getRequestedFor1() {
      const requestedFor = getVisitRequestedDates(this.visit);
      return `${requestedFor.requestedFor1} (${this.bookingSlotStock.requested_booking_slot_1_stock} Remaining)`;
    },
    selectSlot1() {
      this.selectedBookingSlotId = this.visit.requested_booking_slot_1.booking_slot_id;
      this.slotSelected = 'slot1';
    },
    getVisitorsBan() {
      this.loadingVisitorBans = true;

      VisitService.getVisitorsBan(this.visit.visitor.user_id).then(res => {
        this.visitorBans = res.data;
        this.loadingVisitorBans = false;
      }).catch(() => {
        this.$toast.error('Error checking if the visitor is currently banned. Please refresh the page and try again', {
          toastClassName: ['toast-std', 'warning-toast'],
        });
      });
    },
    isUserBannedOnBookingSlot() {
      if (this.slotSelected) {
        let bookingSlot;
        if (this.slotSelected === 'slot1') {
          bookingSlot = this.visit.requested_booking_slot_1;
        } else {
          bookingSlot = this.visit.requested_booking_slot_2;
        }
        if (bookingSlot) {
          const d1 = convertYearDayToDate(bookingSlot.year, bookingSlot.day);
          let banned = false;
          const slotDate = moment(d1);
          this.visitorBans.forEach(ban => {
            const banStartDate = moment(ban.start_date);
            const banEndDate = moment(ban.end_date);
            // Note: the "[]" means inclusive checks on both start and end date
            if (slotDate.isBetween(banStartDate, banEndDate, null, '[]')) {
              banned = true;
            }
          });
          return banned;
        }
      }
      return false;
    },
    validFundTokens() {
      try {
        const fundTokens = parseInt(this.fundTokens, 10);
        return fundTokens > 0;
      } catch (err) {
        return false;
      }
    },
    validApprove() {
      return !!this.selectedBookingSlotId;
    },
    approveVisitWarning(funded) {
      // Check all additional visitors are safeguarded
      if (this.additionalVisitors && this.additionalVisitors.length > 0) {
        let allSafeguarded = true;
        this.additionalVisitors.forEach(addVisitor => {
          if (this.isUnder18(addVisitor) && !addVisitor.safeguarded_at_prison) {
            allSafeguarded = false;
          }
        });
        if (allSafeguarded) {
          this.approveVisit(funded);
        } else {
          // Display warning
          this.$swal({
            title: 'Are you sure?',
            text: 'One or more of the requested additional visitors is under 18 and has not passed through safeguarding checks. Do you still want to approve this visit?',
            icon: 'warning',
            buttons: ['Cancel', 'Approve'],
          }).then(willApprove => {
            if (willApprove) {
              this.approveVisit(funded);
            }
          });
        }
      } else {
        this.approveVisit(funded);
      }
    },
    isUnder18(additionalVisitor) {
      return parseInt(moment(new Date()).diff(additionalVisitor.dob, 'years'), 10) < 18;
    },
    approveVisit(funded) {
      if (funded) {
        this.fundTokens -= 1;
      }
      const dto = {
        funded: funded || false,
        should_record: this.form.recordVisit || false,
        purple_scribe_enabled: (this.form.recordVisit && this.form.purpleScribeEnabled) || false,
        desired_booking_slot_id: this.selectedBookingSlotId,
        security_band: this.form.securityBand,
        adult_content_settings: this.form.adultContentSettings,
        invalid_face_event_action: this.form.invalidFaceEventAction,
        metricAction: 'WebPortalNew',
      };
      this.$toast.info('Processing Approval');

      VisitService.approveVisitFunded(this.visit._id, dto, funded).then(() => {
        this.$toast.success('The visit has been approved');
        this.$emit('refresh');
      }).catch(err => {
        this.fundTokens += 1;
        const error = err && err.response && err.response.data && err.response.data.error;
        const errorMsg = error ? err.response.data.error : '';
        let toastMsg = 'Something went wrong approving the visit, please refresh the page and try again';

        if (errorMsg === ERROR_CODES.VISIT.NOT_OF_STATUS) {
          toastMsg = 'Cannot approve visit as it must have a status of Requested';
        } else if (errorMsg === ERROR_CODES.VISIT.BOOKING_SLOT_NOT_EXIST) {
          toastMsg = 'Cannot approve visit as the selected booking slot does not exist';
        } else if (errorMsg === ERROR_CODES.VISITOR.NOT_VERIFIED) {
          toastMsg = 'Cannot approve visit as the visitor is not verified';
        } else if (errorMsg === ERROR_CODES.VISITOR.BANNED_ON_DATE) {
          toastMsg = 'Cannot approve visit as visitor is banned on the chosen booking slot';
        } else if (errorMsg === ERROR_CODES.VISIT_STOCK.NONE_LEFT) {
          toastMsg = 'Cannot approve visit as the chosen booking slot has no stock left';
        } else if (errorMsg === ERROR_CODES.VISIT.PRISONER_BOOKED_ON_SLOT) {
          toastMsg = `Cannot approve visit as resident #${this.visit.prisoner.prisoner_number} is already booked on another visit during the chosen booking slot`;
        } else if (errorMsg === ERROR_CODES.PRISON.NOT_ENOUGH_FUND_TOKENS) {
          toastMsg = 'Unable to fund visit due to a lack of fund tokens.';
        }

        this.$toast.error(toastMsg, {
          toastClassName: ['toast-std', 'warning-toast'],
        });
      });
    },
    checkRestrictedDates() {
      this.$store.dispatch('booking/getRestrictedDates').then(() => {
        this.$store.dispatch('booking/isDateRestricted', this.visit.requested_booking_slot_1.start_date_time);
      });
    },
  },
};
</script>
